import React from 'react';
import { Typography } from '../../components';
import classNames from 'classnames';

import './Text.scss';

const { Text: AntText } = Typography;

/**
 * @param {'small' | 'base' | 'large'} size
 * @param {'primary' | 'secondary' | 'light' | 'muted'} color
 * @param {boolean} bold
 * @param {boolean} semiBold
 * @param {boolean} extraBold
 * @param {boolean} xxlBold
 * @param {boolean} medLarge
 */
export const Text = ({ size, color, bold, semiBold, extraBold, xxlBold, medLarge, className, ...rest }) => {
    const classes = classNames(
        {
            small: size === 'small',
            large: size === 'large',
            'med-large': size === 'medLarge',
            'extra-large': size === 'extraLarge',
            bold: bold,
            'semi-bold': semiBold,
            'extra-bold': extraBold,
            'xxl-bold': xxlBold,
            'text-primary-blue': color === 'primaryBlue',
            secondary: color === 'secondary',
            'text-light': color === 'light',
            'text-muted': color === 'muted',
        },
        className,
    );

    return <AntText className={classes || undefined} {...rest} />;
};
